import * as Sentry from '@sentry/react';
import { version } from "../../package.json";
import { getSentryDSN, getTracesSampleRate, beforeSend } from "./sentryConfig";

/**
 * Initialize Sentry for React application
 * Includes React-specific integrations like browser tracing and replay
 */
export const initSentry = () => {
  // Only initialize Sentry for upper (production) environments
  const lowerEnvs = ["dev", "qa", "reg", "regression", "uat", "training", "development", "localhost"];
  const env = (import.meta.env.VITE_APP_ENVIRONMENT || "development").toLowerCase();
  if (lowerEnvs.includes(env)) {
    console.log("Sentry disabled for lower environment:", env);
    return;
  }

  const isProd = import.meta.env.VITE_APP_ENVIRONMENT === "prod";

  Sentry.init({
    dsn: getSentryDSN(),
    tracesSampleRate: getTracesSampleRate(),
    environment: import.meta.env.VITE_APP_ENVIRONMENT || "development",
    release: version,
    integrations: [
      Sentry.browserTracingIntegration({
        // Trace navigation and route changes
        enableInp: true, // Interaction to Next Paint
      }),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Replay sample rates at top level (not in integration options)
    replaysSessionSampleRate: isProd ? 0.01 : 0.1,
    replaysOnErrorSampleRate: 1.0,
    sendDefaultPii: true,
    enableLogs: true,
    // Filter sensitive data before sending
    beforeSend: beforeSend as any,
    // Add standard tags
    initialScope: {
      tags: {
        context: "main_thread",
      },
    },
  });
}